export default "__VITE_ASSET__BBK2NAYK__"